/**
 * @fileoverview Breadcrumbs visibility component.
 */

import { postToHost } from "../../../core/messenger";
import { UI_EVENTS } from "../events";
import type { BreadcrumbsSubModule } from "../types";

/**
 * Create the breadcrumbs sub-module.
 */
export function createBreadcrumbsSubModule(): BreadcrumbsSubModule {
  return {
    hide(): void {
      postToHost(UI_EVENTS.BREADCRUMBS, { action: "hide" });
    },
    show(): void {
      postToHost(UI_EVENTS.BREADCRUMBS, { action: "show" });
    },
  };
}
